import { Model } from 'vuex-orm';

import User from '../user/model';

export default class Invoice extends Model {
  static entity = 'invoices';

  static fields() {
    return {
      id: this.attr(null),
      date: this.attr(''),
      company_id: this.attr(''),
      qb_id: this.attr(''),
      client_id: this.attr(''),
      author_id: this.attr(''),
      employee_id: this.attr(''),
      category_id: this.attr(''),
      client_name: this.attr(''),
      ticket_number: this.attr(''),
      status: this.attr(0),
      note: this.attr(''),
      admin_note: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),

      author: this.belongsTo(User, 'author_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/model.js